import { forwardRef } from 'react';
import { Link, type LinkProps } from 'react-router-dom';
import { withRecipientToken } from './withRecipientToken';

export type AttributedLinkProps = LinkProps;

export const AttributedLink = forwardRef<HTMLAnchorElement, AttributedLinkProps>(
  function AttributedLink({ to, ...rest }, ref) {
    // Object `to` props bypass attribution wrapping; T9 migration must use string form.
    const wrappedTo = typeof to === 'string' ? withRecipientToken(to) : to;
    return <Link ref={ref} to={wrappedTo} {...rest} />;
  },
);
